// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__199LL","label":"Completed_label__1URrG"};